// earth3d.vue
<template>
  <div class="earth-3d" ref="earth3dRef" id="earth3dRef"></div>
</template>

<script>
import * as echarts from "echarts"
import "echarts-gl"

import maps from "./mapData.json"
export default {
  data() {
    return {
      myChart: null,
      baseTexture: null,
      code: "world",
      effectScatter: [],
      trainLines: [], // 铁路线集合
      arrows: [], // 箭头集合
      trainNames: [], // 文字标注集合
      maxBeta: 220, // 设置旋转的最大角度
      rotateTimer: null,
      initBeta: 180,
      currentDistance: 230, // 添加当前视角距离属性
      currentAlpha: 30, // 添加当前视角角度属性
      currentBeta: 180 // 添加当前视角角度属性
    }
  },
  mounted() {
    if (!this.webglSupport()) {
      this.message("您的浏览器不支持 WebGL，请切换或升级浏览器")
      return
    }
    this.$nextTick(() => {
      this.myChart = echarts.init(this.$refs.earth3dRef)
      this.initializeMap()
    })
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose()
    }
    if (this.rotateTimer) {
      clearInterval(this.rotateTimer)
      this.initBeta = 180
    }
  },
  methods: {
    // 这段代码会在组件挂载时检查用户的浏览器是否支持 WebGL。如果不支持，会给出提示信息，而不会继续执行图表初始化
    webglSupport() {
      try {
        const canvas = document.createElement("canvas")
        return !!(
          window.WebGLRenderingContext &&
          (canvas.getContext("webgl") ||
            canvas.getContext("experimental-webgl"))
        )
      } catch (e) {
        return false
      }
    },
    // 初始化地图
    initializeMap() {
      this.generateBaseTexture(maps)
      this.drawEarth()
      this.setTimer()
      // 获取地图容器元素
      const mapContainer = this.$refs.earth3dRef
      // 添加滚轮事件监听
      mapContainer.addEventListener("wheel", () => {
        // 获取当前视图的配置
        const viewControl = this.myChart.getOption().globe[0].viewControl
        this.currentDistance = viewControl.distance
      })
    },
    setTimer() {
      this.rotateTimer = setInterval(() => {
        this.initBeta++
        if (this.initBeta > this.maxBeta) {
          clearInterval(this.rotateTimer)
          this.initBeta = 180
          this.currentBeta = this.initBeta
          this.drawEarth()
          this.setTimer()
        }
      }, 1000)
    },

    // 生成基础纹理 可以
    generateBaseTexture(geoJson) {
      // ... [此部分代码你未提供需要修改的具体网格线相关配置，通常2D地图的网格线在geo组件中]
      // 注册geo数据
      echarts.registerMap(this.code, geoJson)
      // 创建画布 生成纹理
      const canvas = document.createElement("canvas")

      this.baseTexture = echarts.init(canvas, null, {
        width: 1920,
        height: 1080
      })

      this.baseTexture.setOption({
        // backgroundColor: "rgba(#7bc7d4, 0.85)", //相当于海洋颜色
        backgroundColor: "rgba(0,0,0, 0)", //相当于海洋颜色
        geo: {
          type: "map",
          silent: true, // 🔴 新增：禁用地理组件的交互和提示，从而去除鼠标高亮[6,7](@ref)
          map: this.code,
          // ... [其他配置如left, top, right, bottom, boundingCoords, roam等]
          itemStyle: {
            areaColor: "rgba(3, 18, 28, 0.1)", // 关键修改：为地图区域颜色添加透明度，例如0.6
            // borderColor: "#314E85",
            // borderColor: "rgba(134, 216, 229, 0.9)",
            borderColor: "rgba(3, 18, 28, 0.5)",
            // 如果geoJson本身带有类似网格的边界线，并希望去除或淡化：
            borderWidth: 0.5 // 可以尝试减小边框宽度
            // borderColor: 'rgba(49, 78, 133, 0.5)', // 或给边框色也加透明度
          }
          // 注意：2D地图选项中的网格线通常由 xAxis/yAxis 的 splitLine 控制，但你的geo配置中未显式使用轴。
          // 如果你的geoJson数据本身包含网格状要素，则需要从数据源或样式上处理。
        },
        series: []
      })
    },

    // 绘制地球
    drawEarth() {
      const option = {
        globe: {
          baseTexture: this.baseTexture, // 使用可能已带有透明度的纹理
          // environment: "/path/to/transparent/or/space/texture", // 可选：使用太空背景图增强透明感[5](@ref)
          // 修改着色类型和材质属性以实现透明效果
          shading: "lambert", // 或 'color'；'realistic' 通常不用于透明效果[5](@ref)
          // 对于ECharts GL的3D地球，透明效果主要通过material和globeMaterial设置
          // 假设使用globeMaterial（如果版本支持）：
          globeMaterial: {
            // 尝试使用带有透明度的材质颜色
            color: "rgba(255, 255, 255, 0.1)" // RGB色和透明度，白色基底可较好透出纹理
            // color: '#fee257', // RGB色和透明度，白色基底可较好透出纹理
            // 或者通过纹理的alpha通道控制透明度
            // opacity: 0, // 全局透明度控制[1](@ref)
      
          },
          // 如果版本较旧或使用不同配置，可尝试：
          material: {
            // opacity: 0.9,
        
          },
          light: {
            ambient: { intensity: 0.9 },
            main: { alpha: -45, beta: 45, intensity: 0.6 }
          },
          atmosphere: {
            show: true,
            color: "rgba(33, 97, 179, 0.1)", // 降低大气层颜色的透明度，例如0.4[5](@ref)
            glowPower: 4
            // 可选：调整大气层强度等进一步优化
            // intensity: 0.8,
          },
          viewControl: {
            /* ... 你的原有配置 ... */
          },
          // 关键：移除或禁用生成网格的layer
          layers: [
            // 移除之前创建经纬网格的layer（type: "blend", texture: 网格纹理）
            // 如果希望完全去除网格，请注释或删除整个layers数组，或移除对应的layer配置
          ],
          top: "2%"
        },
        series: []
      }
      this.myChart.clear()
      this.myChart.setOption(option)
    },

    // 创建经纬网格
    createLatitudeLongitudeGrid() {
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")

      const size = 1024
      canvas.width = size
      canvas.height = size

      ctx.strokeStyle = "#114A72"
      ctx.lineWidth = 1
      ctx.globalAlpha = 0.8

      // 绘制经线
      for (let i = 0; i <= size; i += size / 18) {
        ctx.beginPath()
        ctx.moveTo(i, 0)
        ctx.lineTo(i, size)
        ctx.stroke()
      }

      // 绘制纬线
      for (let j = 0; j <= size; j += size / 9) {
        ctx.beginPath()
        ctx.moveTo(0, j)
        ctx.lineTo(size, j)
        ctx.stroke()
      }
      return canvas
    },

    // 消息提示
    message(text) {
      this.$Message({
        text: text,
        type: "warning"
      })
    }
  }
}
</script>

<style scoped>
.earth-3d {
  width: 800px;
  height: 800px;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  z-index: 1019;
  background-color: transparent !important;
}
</style>
